<template>
  <span v-if="isColoredIcon" :class="[classes, `icon-${name}`]">
    <template v-for="num in numOfPaths"><span :key="num" :class="`path${num}`"></span> </template>
  </span>
  <i v-else :class="classes" :aria-hidden="ariaHidden" @click="$emit('click', $event)">{{ name }}</i>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import DomContentLoadedMixin from 'vuemixins/dom_content_loaded_mixin'
/* type NumberOfPaths = number */
const COLORED_ICONS /*: Record<string, NumberOfPaths> */ = {
  'amazon-color': 2,
  'paypal-color': 3,
  'discover-color': 3,
  'jcb-color': 5,
  'mastercard-color': 3,
  'unionpay-color': 5,
  'amex-color': 2,
  'dinersclub-color': 3,
  'visa-color': 3,
}
export default {
  mixins: [DomContentLoadedMixin],
  props: {
    name: {
      type: String,
      required: true,
      validator: name => !!name,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
      validator: value => ['small', 'normal', 'large'].includes(value),
    },
    ariaHidden: {
      type: String,
      required: false,
      default: 'true',
      validator: value => ['true', 'false'].includes(value),
    },
  },
  computed: {
    isColoredIcon() {
      return Object.keys(COLORED_ICONS).includes(this.name)
    },
    numOfPaths() {
      return COLORED_ICONS[this.name]
    },
    classes() {
      const classList = []
      if (this.isDomLoaded) {
        classList.push('immaterial-icons')
        if (this.size === 'small') {
          classList.push('immaterial-icons-18')
        }
        if (this.size === 'large') {
          classList.push('immaterial-icons-32')
        }
      } else {
        classList.push('immaterial-placeholder')
        if (this.size === 'small') {
          classList.push('immaterial-placeholder-18')
        }
        if (this.size === 'large') {
          classList.push('immaterial-placeholder-32')
        }
      }
      return classList
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/3/partials/fonts/material_icons';

@mixin immaterial-icon {
  font-family: 'immaterial';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;

  /* Enable Ligatures ================ */
  letter-spacing: 0;
  -webkit-font-feature-settings: 'liga';
  -moz-font-feature-settings: 'liga=1';
  -moz-font-feature-settings: 'liga';
  -ms-font-feature-settings: 'liga' 1;
  font-feature-settings: 'liga';
  -webkit-font-variant-ligatures: discretionary-ligatures;
  font-variant-ligatures: discretionary-ligatures;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.immaterial-icons {
  @include immaterial-icon;
}

.immaterial-icons-18 {
  font-size: 18px;
}

.immaterial-icons-32 {
  font-size: 32px;
  padding: 5px;
}

.immaterial-placeholder {
  visibility: hidden;
  width: 24px;
  height: 24px;
  display: inline-block;
}

.immaterial-placeholder-18 {
  visibility: hidden;
  width: 18px;
  height: 18px;
  display: inline-block;
}

.immaterial-placeholder-32 {
  visibility: hidden;
  width: 32px;
  height: 32px;
  padding: 5px;
  display: inline-block;
}
</style>
